import React from "react";
import {
  Box,
  Heading,
  Text,
  Grid,
  Flex,
  useBreakpointValue,
} from "@chakra-ui/react";
import {
  Droplet,
  Heart,
  Thermometer,
  Wind,
  Weight,
  BookOpen,
  Activity,
} from "lucide-react";

interface VitalSignsCardProps {
  isMobile?: boolean;
}

export const PatientVitalSignsCard: React.FC<VitalSignsCardProps> = ({
  isMobile,
}) => {
  const vitalSignsData = [
    {
      icon: Droplet,
      title: "Blood Pressure",
      value: "100/67 mmHg",
      status: "green",
    },
    {
      icon: Heart,
      title: "Heart Rate",
      value: "88 bpm",
      status: "red",
    },
    {
      icon: Activity,
      title: "SPO2",
      value: "96%",
      status: "green",
    },
    {
      icon: Thermometer,
      title: "Temperature",
      value: "101°C",
      status: "green",
    },
    {
      icon: Wind,
      title: "Respiratory rate",
      value: "24 rpm",
      status: "red",
    },
    {
      icon: Weight,
      title: "Weight",
      value: "100 kg",
      status: "green",
    },
  ];

  return (
    <Box
      bg="white"
      borderRadius={{ base: "md", md: "lg" }}
      border="1px solid"
      borderColor="gray.200"
      p={{ base: 3, sm: 4, md: 6 }}
      shadow="sm"
    >
      <Heading
        size="sm"
        mb={4}
        display="flex"
        alignItems="center"
        gap={2}
        fontSize={{ base: "sm", md: "md" }}
      >
        <BookOpen size={isMobile ? 14 : 16} />
        <Text>Vital Signs</Text>
      </Heading>
      <Box borderBottom="1px solid #E7E8EB" pb={2} mb={4}></Box>
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        }}
        gap={{ base: 3, sm: 4, md: 6 }}
        fontSize="sm"
      >
        {vitalSignsData.map((item, index) => (
          <Box key={index}>
            <Flex alignItems="center" gap={2} mb={2}>
              <Box
                w={{ base: "30px", sm: "32px", md: "40px" }}
                h={{ base: "30px", sm: "32px", md: "40px" }}
                rounded="6px"
                border="1px"
                borderColor="gray.200"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexShrink={0}
                p={{ base: "6px", sm: "8px", md: "12px" }}
              >
                <item.icon size={isMobile ? 14 : 16} />
              </Box>
              <Box flex={1}>
                <Text
                  color="gray.900"
                  fontWeight="600"
                  mb={1}
                  fontSize={{ base: "xs", sm: "sm" }}
                  lineHeight="tight"
                >
                  {item.title}
                </Text>
                <Text
                  color="gray.500"
                  fontSize={{ base: "xs", sm: "sm" }}
                  lineHeight="tight"
                >
                  <Text
                    as="span"
                    fontSize={{ base: "10px", sm: "12px", md: "13px" }}
                    color={`${item.status}.500`}
                    mr={1}
                  >
                    ●
                  </Text>
                  {item.value}
                </Text>
              </Box>
            </Flex>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};
